import moment from "@/common/languages/moment";

export const FORMAT_DATE_DEFAULT = "YYYY-MM-DD";
export const FORMAT_TIME_DEFAULT = "HH:mm";
export class TimeFunction {
  public static dateTimeFormatter(
    date: Date,
    format?: string
  ): string | number | Date {
    return moment(date).format(format || FORMAT_DATE_DEFAULT);
  }

  static isEveningMidnight(dateTime: Date) {
    return (
      dateTime.getHours() === 0 &&
      dateTime.getMinutes() === 0 &&
      dateTime.getSeconds() === 0
    );
  }

  public static startOfDay(time: number | string | Date): Date {
    const dateTime = new Date(time);
    dateTime.setHours(0, 0, 0, 0);
    return dateTime;
  }

  public static endOfDay(time: number | string | Date): Date {
    const dateTime = new Date(time);
    dateTime.setHours(23, 59, 59, 999);
    return dateTime;
  }
}

export function overlapCheck(
  startSelected: Date,
  endSelected: Date,
  time2Start: Date,
  time2End: Date
): boolean {
  return startSelected < time2End && time2Start < endSelected;
}

export function convertDateTimeKeepTimezone(date: string): string {
  if (date) {
    if(date.includes("T")) {
      const splitDate = date.split("T");
      const dateOnly = splitDate[0];
      const time = splitDate[1].slice(0, 5);
      return `${dateOnly} ${time}`;
    } else {
      return date;
    }
  }
  return "";
}
